export enum ToolGroupsEnum {
  STANDARD,
  ADVANCED,
  SECURITY,
  ENGINEERING,
  AGRICULTURE
}
